// HaulerCentral Routes Configuration
// Standalone app served from its own domain - no path prefix needed.

export const BASE_PATH = '';

// Route path helpers - use these for all Link to= and navigate() calls
export const ROUTES = {
  HOME: `${BASE_PATH}/`,
  LOGIN: `${BASE_PATH}/login`,
  REGISTER: `${BASE_PATH}/register`,
  VERIFY_EMAIL: `${BASE_PATH}/verify-email`,
  SEARCH: `${BASE_PATH}/search`,
  HAULER: (id: string) => `${BASE_PATH}/haulers/${id}`,
  CLAIM: (id: string) => `${BASE_PATH}/claim/${id}`,
  RFQ: `${BASE_PATH}/rfq`,
  RFQ_CREATE: `${BASE_PATH}/rfq/create`,
  RFQ_DETAIL: (id: string) => `${BASE_PATH}/rfq/${id}`,
  RFQ_EDIT: (id: string) => `${BASE_PATH}/rfq/${id}/edit`,
  PRICE_CHECK: `${BASE_PATH}/price-check`,
  PRICING: `${BASE_PATH}/pricing`,
  PROFILE_MANAGE: `${BASE_PATH}/profile/manage`,
  PROFILE_SETUP: `${BASE_PATH}/profile/setup`,
  PROFILE_RFQS: `${BASE_PATH}/profile/rfqs`,
  PROFILE_RFQ_DETAIL: (id: string) => `${BASE_PATH}/profile/rfqs/${id}`,
  PROFILE_QUOTES: `${BASE_PATH}/profile/quotes`,
  PROFILE_QUOTE_DETAIL: (id: string) => `${BASE_PATH}/profile/quotes/${id}`,
  // Profile creation request routes
  PROFILE_REQUEST: `${BASE_PATH}/profile/request`,
  PROFILE_REQUESTS: `${BASE_PATH}/profile/requests`,
} as const;

// Helper to build search URLs with query params
export function buildSearchUrl(params?: Record<string, string>): string {
  const base = ROUTES.SEARCH;
  if (!params || Object.keys(params).length === 0) {
    return base;
  }
  const searchParams = new URLSearchParams(params);
  return `${base}?${searchParams.toString()}`;
}
